import { LogoSmall } from "@/app/components/common/LogoSmall";


const AppLoader = () => {
  return (
    <div className="gx-custom-spinner-container">
      <div style={{ position: "relative" }}>
        <svg
          className="gx-spinner-svg"
          width="95"
          height="95"
          viewBox="0 0 50 50"
        >
          <circle
            className="gx-spinner-circle"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke="#1e3a8a"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeDasharray="90"
            strokeDashoffset="0"
          />
        </svg>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <LogoSmall />
        </div>
      </div>
    </div>
  );
};

export default AppLoader;
